<div class="bg-white p-4">
    <!-- Page Header -->
    <div class="mb-8 px-2">
        <h1 class="text-2xl font-bold text-gray-900 mb-1">Manual Sorting</h1>
        <p class="text-sm text-gray-500">You will find here all the manual job operations awaiting approval or already
            processed.</p>
    </div>

    <!-- Tabs and Search and Filters -->
    <div class="flex justify-between items-center mb-4 px-2">
        <!-- Left side: Tabs and Search -->
        <div class="flex items-center gap-8">
            <div class="flex">
                <button class="py-2 px-4 text-sm font-semibold focus:outline-none"
                    [ngClass]="activeTab() === 'PENDING' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'"
                    (click)="setActiveTab('PENDING')">
                    Pending
                </button>
                <button class="py-2 px-4 text-sm font-semibold focus:outline-none"
                    [ngClass]="activeTab() === 'APPROVED' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'"
                    (click)="setActiveTab('APPROVED')">
                    Approved
                </button>
                <button class="py-2 px-4 text-sm font-semibold focus:outline-none"
                    [ngClass]="activeTab() === 'REJECTED' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'"
                    (click)="setActiveTab('REJECTED')">
                    Rejected
                </button>
            </div>
            <div class="flex items-center space-x-3">
                <button *ngIf="activeTab() === 'PENDING' && selectedItemIds().length > 0" (click)="rejectSelected()"
                    class="text-gray-400 bg-transparent hover:bg-gray-100 border border-gray-300 px-3 py-2.5 rounded text-xs font-semibold focus:outline-none transition-colors ml-2 whitespace-nowrap">
                    Reject Selected ({{ selectedItemIds().length }})
                </button>
                <button *ngIf="activeTab() === 'PENDING' && selectedItemIds().length > 0" (click)="approveSelected()"
                    class="text-white bg-blue-600 hover:bg-blue-700 px-3 py-2.5 rounded text-xs font-semibold focus:outline-none transition-colors ml-2 whitespace-nowrap">
                    Approve Selected ({{ selectedItemIds().length }})
                </button>
            </div>
        </div>

        <!-- Right side: Date Filters -->
        <div class="flex items-center space-x-2">
            <!-- Search Job -->
            <input type="text" class="textField w-32" placeholder="Search Job..." [ngModel]="searchJobNo()"
                (ngModelChange)="searchJobNo.set($event)" />

            <!-- Filter Button & Dropdown -->
            <div class="relative filter-container">
                <button (click)="toggleFilterDropdown()"
                    class="whitespace-nowrap flex items-center space-x-2 border border-gray-100 rounded-md px-3 py-2 text-sm font-semibold text-gray-600  hover:bg-gray-100 transition-colors">
                    <i class="fa fa-filter"></i>
                    <span>Filters</span>
                </button>

                <!-- Filter Popover -->
                <div *ngIf="showFilterDropdown"
                    class="absolute left-0 mt-2 w-[420px] bg-white border border-gray-200 rounded-xl shadow-xl z-50 p-4">
                    <h4 class="text-sm font-semibold text-gray-800 mb-4">Filter content where:</h4>

                    <div class="space-y-4">
                        <!-- Operator Dropdown with Direct Search Bar -->
                        <div class="flex items-center gap-2">
                            <span class="text-sm font-medium text-gray-700 w-16">Operator</span>
                            <span class="text-sm text-gray-400">Is</span>
                            <div class="relative flex-1 operator-dropdown-container">
                                <!-- Search Input Bar -->
                                <div class="relative flex items-center">
                                    <input type="text"
                                        class="textField w-full py-1.5 pl-3 pr-8 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Search operator..." [ngModel]="operatorSearchText()"
                                        (ngModelChange)="onOperatorSearchChange($event)"
                                        (focus)="isOperatorDropdownOpen = true"
                                        (click)="$event.stopPropagation(); isOperatorDropdownOpen = true" />
                                    <i
                                        class="fa fa-search absolute right-3 text-gray-400 text-xs pointer-events-none"></i>
                                </div>

                                <!-- Dropdown Menu Options -->
                                <div *ngIf="isOperatorDropdownOpen"
                                    class="absolute left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-1 text-sm max-h-48 overflow-y-auto divide-y divide-gray-50">

                                    <div (click)="selectOperator(null, $event)"
                                        class="px-3 py-1.5 hover:bg-blue-50 cursor-pointer rounded transition-colors flex items-center justify-between text-gray-700"
                                        [ngClass]="{'bg-blue-50 font-medium text-blue-600': tempSelectedOperatorId === null}">
                                        <span>Any</span>
                                        <i *ngIf="tempSelectedOperatorId === null"
                                            class="fa fa-check text-blue-600 text-xs"></i>
                                    </div>

                                    <div *ngFor="let op of filteredOperators" (click)="selectOperator(op, $event)"
                                        class="px-3 py-1.5 hover:bg-blue-50 cursor-pointer rounded transition-colors flex items-center justify-between text-gray-700"
                                        [ngClass]="{'bg-blue-50 font-medium text-blue-600': tempSelectedOperatorId === op.operatorId}">
                                        <span>{{ op.operatorName | titlecase }}</span>
                                        <i *ngIf="tempSelectedOperatorId === op.operatorId"
                                            class="fa fa-check text-blue-600 text-xs"></i>
                                    </div>

                                    <div *ngIf="filteredOperators.length === 0"
                                        class="px-3 py-2 text-xs text-gray-400 text-center">
                                        No operators found
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Shift Dropdown -->
                        <div class="flex items-center gap-2">
                            <span class="text-sm font-medium text-gray-700 w-16">Shift</span>
                            <span class="text-sm text-gray-400">Is</span>
                            <select class="textField flex-1 py-1.5 text-sm" [(ngModel)]="tempSelectedShiftId">
                                <option [ngValue]="null">Any</option>
                                <option *ngFor="let s of shiftService.all()[0]?.shifts" [ngValue]="s.shiftId">
                                    {{ s.shiftName | titlecase }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="flex justify-between items-center mt-6 pt-4 border-t border-gray-100">
                        <button
                            class="text-gray-400 hover:text-red-600 text-sm font-medium rounded flex items-center transition-colors"
                            (click)="clearFilters()">
                            <i class="fa fa-trash-o mr-1"></i> Clear
                        </button>
                        <div class="flex gap-2">
                            <button
                                class="text-gray-600 hover:text-gray-800 text-sm font-medium px-3 py-1.5 transition-colors"
                                (click)="showFilterDropdown = false">
                                Cancel
                            </button>
                            <button
                                class="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-1.5 rounded transition-colors"
                                (click)="applyFilters()">
                                Apply Filter
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <button (click)="toggleCustomRange()"
                class="button-white whitespace-nowrap mr-2 border border-gray-100 rounded-md px-3 py-2 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                {{ showCustomRange() ? 'Month View' : 'Custom Range' }}
            </button>

            <ng-container *ngIf="!showCustomRange()">
                <select [(ngModel)]="selectedYearValue" (change)="onMonthYearChange()" class="textField w-24">
                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                </select>
                <select [(ngModel)]="selectedMonthValue" (change)="onMonthYearChange()" class="textField w-32">
                    <option *ngFor="let month of months; let i = index" [value]="i">{{ month }}</option>
                </select>
            </ng-container>

            <ng-container *ngIf="showCustomRange()">
                <input type="date" class="textField" [(ngModel)]="manualStartDate" />
                <span class="text-sm font-medium text-gray-500">to</span>
                <input type="date" class="textField" [(ngModel)]="manualEndDate" />
                <button (click)="applyManualDateRange()" class="button-blue whitespace-nowrap">Apply</button>
            </ng-container>
        </div>
    </div>

    <div class="overflow-hidden h-[calc(100vh-222px)] flex flex-col rounded-xl border border-gray-200 shadow-sm mx-2">
        <div class="overflow-auto scrollbar-hide h-full">
            <table class="min-w-full w-full">
                <thead class="sticky top-0 z-20 bg-gray-50 border-b">
                    <tr>
                        <th
                            class="px-4 py-3 text-center transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider w-10">
                            <input type="checkbox" [checked]="isAllSelected()"
                                [indeterminate]="isSomeSelected() && !isAllSelected()" (change)="toggleAll($event)"
                                class="rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer">
                        </th>
                        <th (click)="sortBy('jobNo')"
                            class="cursor-pointer hover:bg-gray-100 px-4 py-3 text-center transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Job Number
                            <i *ngIf="sortColumn() !== 'jobNo'" class="fa fa-sort ml-1 text-gray-300"></i>
                            <i *ngIf="sortColumn() === 'jobNo'" class="fa ml-1"
                                [ngClass]="sortDirection() === 'asc' ? 'fa-sort-up text-blue-500' : 'fa-sort-down text-blue-500'"></i>
                        </th>
                        <th (click)="sortBy('customer')"
                            class="cursor-pointer hover:bg-gray-100 px-4 py-3 text-left transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider w-32 max-w-[128px]">
                            Customer
                            <i *ngIf="sortColumn() !== 'customer'" class="fa fa-sort ml-1 text-gray-300"></i>
                            <i *ngIf="sortColumn() === 'customer'" class="fa ml-1"
                                [ngClass]="sortDirection() === 'asc' ? 'fa-sort-up text-blue-500' : 'fa-sort-down text-blue-500'"></i>
                        </th>
                        <th
                            class="px-4 py-3 text-left transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider w-48 max-w-[192px]">
                            Description</th>
                        <th
                            class="px-4 py-3 text-center transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Output (Sheets)</th>
                        <th (click)="sortBy('name')"
                            class="cursor-pointer hover:bg-gray-100 px-4 py-3 text-center transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Name (EmpNo)
                            <i *ngIf="sortColumn() !== 'name'" class="fa fa-sort ml-1 text-gray-300"></i>
                            <i *ngIf="sortColumn() === 'name'" class="fa ml-1"
                                [ngClass]="sortDirection() === 'asc' ? 'fa-sort-up text-blue-500' : 'fa-sort-down text-blue-500'"></i>
                        </th>
                        <th (click)="sortBy('startedDateTime')"
                            class="cursor-pointer hover:bg-gray-100 px-4 py-3 text-center transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Started
                            <i *ngIf="sortColumn() !== 'startedDateTime'" class="fa fa-sort ml-1 text-gray-300"></i>
                            <i *ngIf="sortColumn() === 'startedDateTime'" class="fa ml-1"
                                [ngClass]="sortDirection() === 'asc' ? 'fa-sort-up text-blue-500' : 'fa-sort-down text-blue-500'"></i>
                        </th>
                        <th (click)="sortBy('endedDateTime')"
                            class="cursor-pointer hover:bg-gray-100 px-4 py-3 text-center transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Completed
                            <i *ngIf="sortColumn() !== 'endedDateTime'" class="fa fa-sort ml-1 text-gray-300"></i>
                            <i *ngIf="sortColumn() === 'endedDateTime'" class="fa ml-1"
                                [ngClass]="sortDirection() === 'asc' ? 'fa-sort-up text-blue-500' : 'fa-sort-down text-blue-500'"></i>
                        </th>
                        <th
                            class="px-4 py-3 text-center transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Shift</th>
                        <th *ngIf="activeTab() === 'PENDING'"
                            class="px-4 py-3 text-center transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Action</th>
                        <th *ngIf="activeTab() === 'APPROVED'"
                            class="px-4 py-3 text-center transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Approved By</th>
                        <th *ngIf="activeTab() === 'REJECTED'"
                            class="px-4 py-3 text-center transition-colors text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Rejected By</th>
                    </tr>
                </thead>
                <tbody class="bg-white">
                    <tr *ngIf="loading()" class="border-b border-gray-100">
                        <td colspan="11" class="px-4 py-3 text-center text-sm font-medium text-gray-500">Loading...</td>
                    </tr>
                    <tr *ngIf="!loading() && getCurrentData().length === 0" class="border-b border-gray-100">
                        <td colspan="11" class="px-4 py-3 text-center text-sm font-medium text-gray-500">No records
                            found.</td>
                    </tr>
                    <tr *ngFor="let item of getCurrentData()"
                        class="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                        <td class="px-4 py-3 text-center">
                            <input type="checkbox" [checked]="selectedItemIds().includes(item.id)"
                                [disabled]="item?.jobStatus?.toLowerCase() !== 'completed'"
                                (change)="toggleSelection(item.id)"
                                class="rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed">
                        </td>
                        <td class="px-4 py-3 text-center whitespace-nowrap text-sm font-bold text-gray-900">{{
                            item.jobNo }}</td>
                        <td class="px-4 py-3 text-left text-sm font-medium text-gray-500 w-32 max-w-[128px] truncate"
                            title="{{ item.customer }}">{{ item.customer }}</td>
                        <td class="px-4 py-3 text-left text-sm font-medium text-gray-500 w-48 max-w-[192px] truncate"
                            title="{{ item.jobDescription }}">{{ item.jobDescription }}</td>
                        <td class="px-4 py-3 text-center whitespace-nowrap text-sm font-bold text-gray-900">{{
                            item.noOfSheets }}</td>
                        <td class="px-4 py-3 text-center whitespace-nowrap text-sm font-medium text-gray-500">{{
                            item.name }} <span class="text-xs text-gray-500">({{ item.empNo }})</span></td>
                        <td class="px-4 py-3 text-center whitespace-nowrap text-sm font-medium text-gray-500">{{
                            item.startedDateTime | date:'short' }}</td>
                        <td class="px-4 py-3 text-center whitespace-nowrap text-sm font-medium text-gray-500">{{
                            item.endedDateTime | date:'short' }}</td>
                        <td class="px-4 py-3 text-center whitespace-nowrap text-sm font-medium text-gray-500">{{
                            item.shift }}</td>
                        <td *ngIf="activeTab() === 'PENDING'"
                            class="px-4 py-3 text-center whitespace-nowrap text-sm font-medium text-gray-500 space-x-2">
                            <button (click)="rejectItem(item)"
                                class="text-gray-400 bg-transparent hover:bg-gray-200 border border-gray-300 px-3 py-1.5 rounded text-xs font-semibold focus:outline-none transition-colors">
                                Reject
                            </button>
                            <button (click)="approveItem(item)"
                                [disabled]="item?.jobStatus?.toLowerCase() !== 'completed'"
                                class="text-white bg-blue-600 hover:bg-blue-700 px-3 py-1.5 rounded text-xs font-semibold focus:outline-none transition-colors disabled:opacity-40 disabled:bg-gray-400 disabled:cursor-not-allowed">
                                Approve
                            </button>
                        </td>
                        <td *ngIf="activeTab() === 'APPROVED'"
                            class="px-4 py-3 text-center whitespace-nowrap text-sm font-medium text-gray-500">
                            {{ item.approvedBy || '-' }}
                        </td>
                        <td *ngIf="activeTab() === 'REJECTED'"
                            class="px-4 py-3 text-center whitespace-nowrap text-sm font-medium text-gray-500">
                            {{ item.rejectedBy || '-' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

@if(modalService.$$manualApproveConfirm()){
<div id="approval-modal" tabindex="-1" aria-hidden="true"
    class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
    <div class="relative p-4 w-full max-w-md mx-auto bg-white rounded-lg shadow-lg">
        <div class="relative">
            <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    <span>{{ approvalAction() === 'APPROVED' ? 'Confirm Approval' : 'Confirm Rejection' }}</span>
                </h3>
                <button type="button" (click)="closeApproveModal()" [disabled]="isApproving()"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center disabled:opacity-50 disabled:cursor-not-allowed">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
        </div>

        <div class="p-4 space-y-4">
            <p class="text-gray-600 text-base" *ngIf="!isApproving()">
                Are you sure you want to {{ approvalAction() === 'APPROVED' ? 'approve' : 'reject' }} the {{
                selectedForApproval().length }} selected job(s)?
            </p>

            <div *ngIf="isApproving()" class="mt-4">
                <p class="text-center text-sm font-semibold mb-2 text-gray-700">{{ approvalAction() === 'APPROVED' ?
                    'Approving' : 'Rejecting' }}... Complete {{ approvedCount()
                    }} out of {{ selectedForApproval().length }}</p>
                <div class="w-full bg-gray-200 rounded-full h-2.5">
                    <div class="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
                        [style.width.%]="(approvedCount() / selectedForApproval().length) * 100"></div>
                </div>
            </div>

            <div class="flex justify-end gap-3 pt-4 border-t mt-4">
                <button class="button-secondary disabled:opacity-50 disabled:cursor-not-allowed"
                    (click)="closeApproveModal()" [disabled]="isApproving()">
                    Cancel
                </button>
                <button
                    class="button-blue disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    (click)="confirmApproval()" [disabled]="isApproving()">
                    <span *ngIf="isApproving()"><i class="fa fa-spinner fa-spin mr-2"></i>Processing...</span>
                    <span *ngIf="!isApproving()">Confirm</span>
                </button>
            </div>
        </div>
    </div>
</div>
}